module.exports = __webpack_public_path__ + "img/Gaps Between Stones.32f14ad5.png";